import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Lock, Sparkles } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-cream-dark px-6" data-id="element-139">
      <div className="container mx-auto max-w-4xl" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-amber/20 relative" data-id="element-141">
          {/* Discount Badge - Absolute Positioned */}
          <div className="absolute top-4 right-4 md:top-8 md:right-8 z-20 rotate-3" data-id="element-142">
            <span className="bg-red-500 text-white px-4 py-2 rounded-full font-bold text-sm md:text-base shadow-lg flex items-center gap-2 animate-pulse" data-id="element-143">
              <Sparkles className="w-4 h-4" data-id="element-144" />
              -42% DESCUENTO
            </span>
          </div>

          <div className="bg-wine-dark p-8 md:p-12 text-center text-white relative overflow-hidden" data-id="element-145">
            <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-146"></div>
            <h2 className="text-3xl md:text-5xl font-bold mb-4 relative z-10" data-id="element-147">
              Empieza esta noche
            </h2>
            <p className="text-amber-light text-xl relative z-10" data-id="element-148">
              Acceso inmediato a la guía digital
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-149">
            {/* Price Display with Psychology */}
            <div className="flex flex-col items-center justify-center mb-8" data-id="element-150">
              <div className="flex items-center gap-3 mb-2" data-id="element-151">
                <span className="text-2xl text-charcoal/40 line-through decoration-red-500/50 decoration-2 font-serif" data-id="element-152">
                  $11.00
                </span>
                <span className="bg-amber/20 text-amber-dark px-2 py-0.5 rounded text-xs font-bold uppercase tracking-wide" data-id="element-153">
                  Oferta Limitada
                </span>
              </div>

              <div className="flex items-baseline gap-2" data-id="element-154">
                <span className="text-7xl md:text-8xl font-bold text-wine-dark tracking-tight" data-id="element-155">
                  $6.39
                </span>
                <span className="text-charcoal/60 text-xl font-medium" data-id="element-156">
                  USD
                </span>
              </div>
              <p className="text-sm text-charcoal/50 mt-2" data-id="element-157">
                Pago único · Acceso de por vida
              </p>
            </div>

            <p className="text-lg text-charcoal/70 mb-10 max-w-lg mx-auto" data-id="element-158">
              Te cuesta menos que una salida rápida… y te deja con un sistema
              que pueden repetir siempre que lo necesiten.
            </p>

            {/* Magnetic CTA Button */}
            <a href="https://everythingfouryou.com/cart/47962139132129:1" target="_blank" rel="noopener noreferrer" data-id="element-159">
              <motion.button whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.98
            }} animate={{
              boxShadow: ['0 0 0 0 rgba(212, 165, 116, 0)', '0 0 0 10px rgba(212, 165, 116, 0.1)', '0 0 0 20px rgba(212, 165, 116, 0)']
            }} transition={{
              boxShadow: {
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut'
              }
            }} className="w-full md:w-auto px-12 py-6 bg-gradient-to-r from-amber to-amber-dark hover:from-amber-light hover:to-amber text-wine-dark font-bold text-2xl rounded-full shadow-xl transition-all duration-300 flex items-center justify-center mx-auto gap-3 group relative overflow-hidden" data-id="element-160">
                <span className="relative z-10" data-id="element-161">Descargar la Guía Ahora</span>
                <ArrowRight className="w-7 h-7 relative z-10 group-hover:translate-x-1 transition-transform" data-id="element-162" />

                {/* Shine effect */}
                <div className="absolute inset-0 bg-white/20 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 skew-x-12" data-id="element-163"></div>
              </motion.button>
            </a>

            <div className="mt-8 flex flex-col items-center gap-3" data-id="element-164">
              <div className="flex items-center justify-center gap-2 text-sm text-charcoal/50" data-id="element-165">
                <Lock className="w-4 h-4" data-id="element-166" />
                <span data-id="element-167">Pago seguro y encriptado con SSL</span>
              </div>
              <p className="text-xs text-green-600 font-medium bg-green-50 px-3 py-1 rounded-full border border-green-100" data-id="element-168">
                Más de 200 parejas ya empezaron esta semana
              </p>
            </div>

            <div className="mt-12 pt-12 border-t border-gray-100" data-id="element-169">
              <p className="font-serif italic text-xl text-charcoal/80" data-id="element-170">
                "Si quieres que esta semana se sienta distinta — no perfecta,{' '}
                <strong className="text-wine" data-id="element-171">distinta</strong> — entra ahora y
                hagan la Noche 1 hoy."
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}